import { Client } from '@medigo/medigo-sdk';
import { CurrentEnv } from '@proccess/constants';
import Cookies from 'js-cookie';

const sdk = new Client({
  apiRoot: CurrentEnv.API_BE,
  jwtToken: Cookies.get('jwt') || undefined,
} as any);

export default sdk;
